import { render, staticRenderFns } from "./SearchArticleWithStockModel.vue?vue&type=template&id=63edf39a&scoped=true"
import script from "./SearchArticleWithStockModel.vue?vue&type=script&lang=js"
export * from "./SearchArticleWithStockModel.vue?vue&type=script&lang=js"
import style0 from "./SearchArticleWithStockModel.vue?vue&type=style&index=0&id=63edf39a&prod&scoped=true&lang=css"
import style1 from "./SearchArticleWithStockModel.vue?vue&type=style&index=1&id=63edf39a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63edf39a",
  null
  
)

export default component.exports